<template>
<div class="c-panel c-panel--border c-panel--no-shadow margin-b-24">
		<h4>{{asn.reference}}</h4>
		<div class="fs-small color-gray-500 margin-b-16" v-if="asn.user">Aangevraagd door {{ asn.user.name }} </div>

		<c-splitbutton class="margin-b-24" :buttons="buttons"></c-splitbutton>

		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Eindklant</span>
			</div>
			<div class="columns small-12 medium-8">
				{{asn.client.name}}
			</div>
		</div>
    <div class="row margin-b-16 fs-xsmall">
        <div class="columns small-12 medium-4">
            <span class="color-gray-600 font-heading">Aanmelddatum</span>
        </div>
        <div class="columns small-12 medium-8">
            {{datetime(asn.created_at, true)}}
        </div>
    </div>
		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Verwachte leverdatum</span>
			</div>
			<div class="columns small-12 medium-8">
				{{datetime(asn.expected, false)}}
			</div>
		</div>
		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Deellevering</span>
			</div>
			<div class="columns small-12 medium-8">
				{{asn.partial_delivery ? "Ja" : "Nee"}}
			</div>
		</div>
    <div class="row margin-b-16 fs-xsmall">
        <div class="columns small-12 medium-4">
            <span class="color-gray-600 font-heading">Ordernummer</span>
        </div>
        <div class="columns small-12 medium-8">
            {{asn.reference}}
        </div>
    </div>
	<div class="row margin-b-16 fs-xsmall">
        <div class="columns small-12 medium-4">
            <span class="color-gray-600 font-heading">Startdatum contract</span>
        </div>
        <div class="columns small-12 medium-8">
            {{datetime(asn.start_date_contract)}}
        </div>
    </div>
	<div class="row margin-b-16 fs-xsmall">
        <div class="columns small-12 medium-4">
            <span class="color-gray-600 font-heading">Einddatum contract</span>
        </div>
        <div class="columns small-12 medium-8">
			{{datetime(asn.end_date_contract)}}
        </div>
    </div>
	<div class="row margin-b-16 fs-xsmall">
		<div class="columns small-12 medium-4">
			<span class="color-gray-600 font-heading">DaaS</span>
		</div>
		<div class="columns small-12 medium-8">
			{{asn.daas ? "Ja" : "Nee"}}
		</div>
	</div>
    <div class="row margin-b-16 fs-xsmall">
        <div class="columns small-12 medium-4">
            <span class="color-gray-600 font-heading">Projectnummer</span>
        </div>
        <div class="columns small-12 medium-8">
            {{getProjectNumber}}
        </div>
    </div>
        <div class="row margin-b-16 fs-xsmall">
            <div class="columns small-12 medium-4">
                <span class="color-gray-600 font-heading">Topdesk nummer</span>
            </div>
            <div class="columns small-12 medium-8">
                {{asn.w_number}}
            </div>
        </div>
		<div class="row margin-b-16 fs-xsmall">
			<div class="columns small-12 medium-4">
				<span class="color-gray-600 font-heading">Opmerking</span>
			</div>
			<div class="columns small-12 medium-8">
				{{asn.comment}}
			</div>
		</div>
	</div>
</template>

<script>
import CSplitbutton from '@components/Splitbutton';
import { mapGetters } from 'vuex';

export default {
	components: { CSplitbutton },
	props: {
		asn: {
			type: Object,
			required: true
		}
	},
	methods: {
		datetime(value, hours = false){
			if ( typeof value == 'string' && value.trim() != '' ) {
				let date = new Date(value);

				if ( isNaN(date.getTime()) === false ) {

					if(hours){
						return date.toLocaleDateString('nl-NL', {day: 'numeric', month:'numeric', year: 'numeric',  hour: 'numeric', minute: 'numeric', hour12: false})
					}
					else {
						return date.toLocaleDateString('nl-NL', {day: 'numeric', month:'numeric', year: 'numeric'})
					}
				}
    		}
		},
		trigger(event) {
				this.$store.dispatch('listener/emit', event);
		},
	},
	computed: {
		...mapGetters({
			can: 'user/can',
		}),
		buttons() {

			const buttons = [];
			this.can('Voormelding wijzigen') && buttons.push({
				label: 'Bewerken',
				action: () => {
					this.trigger('new-prenotification');
				},
			});
			this.can('Voormelding verwijderen') && buttons.push({
				label: 'Verwijderen',
				action: () => {
					this.trigger('remove-prenotification');
				},
			});

			return buttons;
		},
        getProjectNumber() {
            return this.asn.project ? this.asn.project.number : '';
        }
	},
	mounted(){

	}
}
</script>
